module.exports = __webpack_public_path__ + "static/user-f8ca1c5b5478aadf9ca0881bb8abd2a5.png";